import equal from 'lodash.isequal'


class Text {
  constructor(text, data) {
    this.text = text
    this.data = data || {}
  }

  isEqual(textNode) {
    return textNode instanceof Text
      && this.text === textNode.text
      && equal(this.data, textNode.data)
  }
}

export default Text